import Operation from './Operation'
import Subject from './Subject'
import Payment from './Payment'
import BankAccount from './BankAccount'


export default class CurrencySelect {
  constructor(component) {
    this.component = component
    this.component.selected_from_currency = null
    this.component.selected_to_currency = null
  }
  name() {
    return 'currency_select'
  }
  handle(event) {
    if(event.back) {
      this.component.selected_operation = null
      this.component.transaction_controller = new Operation(this.component)
      return
    }
    if(event.selected_operation) {
      this.component.selected_operation = event.selected_operation
      this.component.selected_from_currency = event.from_currency
      this.component.selected_to_currency = event.to_currency
      const getOperationFlow = (operation) => {
        if (operation == 'exchange_internal') return 'both'
        if (operation == 'fee_payoff') return 'facilita_cash_out'
        if (['receive', 'withdrawal_internal'].includes(operation)) return 'cash_in'
        return 'cash_out'
      }
      this.component.operation_flow = getOperationFlow(event.selected_operation)
      switch(event.selected_operation) {
        case 'receive':
        case 'pay':
          this.component.transaction_controller = new Subject(this.component)
          break
        case 'deposit':
        case 'fee_payoff':
        case 'exchange_internal':
          this.component.transaction_controller = new Payment(this.component)
          break
        case 'withdrawal_internal':
          this.component.transaction_controller = new BankAccount(this.component)
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/CurrencySelect.js